import React, { useRef, MutableRefObject } from 'react';
import { ButtonColor, Flex, FlexBehavior, FlexDirection, FlexJustify, Tooltip } from 'react-magma-dom';
import { Modal } from './Modal';
import { MarginWrapper, StyledEllipsisWrapper, StyledSavedText, StyledSavedWrapper } from '../Styled';
import { StyledModalConfirmBtn } from '../Styled/StyledButtons';
import { COLORS } from '../../constants';
import { useTooltipForLongName } from '../../hooks/useLongNameTooltip';

interface ISavedModal {
  name: string;
  textType: string;
  stage: string;
  mainColor: string;
  highlightColor: string;
  isUpdated?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SavedModal: React.FC<ISavedModal> = (props): JSX.Element => {
  const { name, textType, stage, mainColor, highlightColor, isUpdated, onClose, onConfirm } = props;

  const ellipsisWrapperRef = useRef() as MutableRefObject<HTMLDivElement>;
  const styledTextNameRef = useRef() as MutableRefObject<HTMLSpanElement>;

  const isTooltip = useTooltipForLongName(ellipsisWrapperRef, styledTextNameRef);

  const showName = (withTooltip: boolean): JSX.Element => {
    const defaultNameElement = (
      <StyledEllipsisWrapper ref={ellipsisWrapperRef} radius={2} width={555} behavior={FlexBehavior.item}>
        <StyledSavedText ref={styledTextNameRef} bgColor={highlightColor}>
          {name}
        </StyledSavedText>
      </StyledEllipsisWrapper>
    );

    const tooltipStyle = {
      minWidth: 'fit-content',
    };

    return withTooltip ? (
      <Tooltip testId="longname-modal-tooltip" tooltipStyle={tooltipStyle} content={name} data-testId="name-tooltip">
        {defaultNameElement}
      </Tooltip>
    ) : (
      defaultNameElement
    );
  };

  return (
    <Modal headerText="Saved!" headerColor={mainColor} onCloseClick={onClose}>
      <MarginWrapper margin="0px 0px 23px 0px">
        <Flex
          testId="saved-modal-text"
          behavior={FlexBehavior.container}
          justify={FlexJustify.center}
          direction={FlexDirection.column}
        >
          <StyledSavedWrapper behavior={FlexBehavior.container} justify={FlexJustify.center}>
            {showName(isTooltip)}
            <span>&nbsp;{' is saved under '}</span>
          </StyledSavedWrapper>
          <Flex behavior={FlexBehavior.item}>
            <StyledSavedWrapper behavior={FlexBehavior.container} justify={FlexJustify.center}>
              <StyledSavedText>{textType}</StyledSavedText>
              {' in '}
              <StyledSavedText>{stage}</StyledSavedText>
            </StyledSavedWrapper>
          </Flex>
        </Flex>
      </MarginWrapper>
      <StyledModalConfirmBtn
        testId="confirm-btn"
        bGColor={mainColor}
        onClick={onConfirm}
        textColor={COLORS.white as ButtonColor}
      >
        {isUpdated ? 'Continue' : 'View new text'}
      </StyledModalConfirmBtn>
    </Modal>
  );
};
